class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetFormEl = this.querySelector('form');
    if (facetFormEl) {
      facetFormEl.addEventListener('change', (event) => {
        const checkbox = event.target;
        if (checkbox.type !== 'checkbox') return;
        const label = checkbox.closest('label');
        const visibleSpan = label && label.querySelector('span[aria-hidden="true"]');
        const filterName = visibleSpan ? visibleSpan.textContent.trim() : (checkbox.value || '');
        const groupLegend = checkbox.closest('fieldset') && checkbox.closest('fieldset').querySelector('legend');
        const groupName = groupLegend ? groupLegend.textContent.trim() : '';
        const action = checkbox.checked ? 'has been selected' : 'has been deselected';
        const message = (checkbox.value || '') + ' ' + action;

        const announcer = document.createElement('div');
        announcer.setAttribute('aria-live', 'assertive');
        announcer.setAttribute('role', 'alert');
        announcer.setAttribute('aria-atomic', 'true');
        announcer.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;';
        document.body.appendChild(announcer);
        setTimeout(() => { announcer.textContent = message; }, 100);
        setTimeout(() => { document.body.removeChild(announcer); }, 3000);
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    //location.reload();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    let elem = document.querySelector('#product-grid');
        let infScroll = new InfiniteScroll( elem, {
          // options
          path: '.pagination__next',
          append: '.product-grid .grid__item',
          status: '.scroller-status',
          hideNav: '.pagination-wrapper',
          history: false
        });
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }


    const productTiles = document.querySelectorAll('.grid__item');
    const lastSelectedSwatches = new Map();
  
    productTiles.forEach(tile => {
      const swatchesColorElements = tile.querySelectorAll('.js-QuickAddProductSwatch');
  
      swatchesColorElements.forEach(swatchesColor => {
        swatchesColor.addEventListener('click', () => {
          if (typeof popupopen === 'function') {
            popupopen(swatchesColor.getAttribute('data-popup-val'));
          }
          selectSwatch(swatchesColor, tile);
        });

        swatchesColor.addEventListener('keydown', (event) => {
          if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            if (typeof popupopen === 'function') {
              popupopen(swatchesColor.getAttribute('data-popup-val'));
            }
            selectSwatch(swatchesColor, tile);
            announceChecked();
          }
          if (event.keyCode === 32 ) {

            event.preventDefault();
          }
        });
  
        swatchesColor.addEventListener('focus', () => {
          updateAriaLabel(swatchesColor, tile);
        });
        initializeSwatch(swatchesColor, tile);
      });
    });
  
    function initializeSwatch(swatch, tile) {
      const defaultLabel = swatch.getAttribute('aria-label');
      swatch.setAttribute('data-default-label', defaultLabel);
  
      if (swatch.classList.contains('Product__swatch--active')) {
        swatch.setAttribute('aria-label', `${defaultLabel} checked`);
        swatch.setAttribute('aria-checked', 'true');
        lastSelectedSwatches.set(tile, swatch);
      }
    }
  
    function selectSwatch(swatch, tile) {
      const swatchesColorElements = tile.querySelectorAll('.js-QuickAddProductSwatch');
      
      swatchesColorElements.forEach(el => {
        el.classList.remove('selected', 'Product__swatch--active');
        el.setAttribute('aria-checked', 'false');
        el.setAttribute('aria-label', el.getAttribute('data-default-label'));
      });
  
      swatch.classList.add('selected', 'Product__swatch--active');
      swatch.setAttribute('aria-checked', 'true');
      lastSelectedSwatches.set(tile, swatch);
      updateAriaLabel(swatch, tile);
    }
  
    function updateAriaLabel(swatch, tile) {
      const defaultLabel = swatch.getAttribute('data-default-label');
      if (swatch === lastSelectedSwatches.get(tile) || swatch.classList.contains('Product__swatch--active')) {
        swatch.setAttribute('aria-label', `${defaultLabel} checked`);
      } else {
        swatch.setAttribute('aria-label', defaultLabel);
      }
    }
  
    function announceChecked() {
      const announcement = document.createElement('div');
      announcement.setAttribute('role', 'status');
      announcement.setAttribute('aria-live', 'assertive');
      announcement.textContent = 'checked';
      document.body.appendChild(announcement);
  
      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 100);
    }

    $(".motion-reduce").on("keydown", function (event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        const url = $(this).attr('data-url'); 
        if (url) {
          window.location.href = url;
        } else {
          console.error('URL is null or undefined');
        }
      }
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }
  
  static parseQueryString(queryString) {
    return queryString.split('&').map(param => {
      const [key, value] = param.split('=');
      return { key, value };
    });
  }

  static reconstructQueryString(params) {
    return params.map(param => `${param.key}=${param.value}`).join('&');
  }

  static updateURLHash(searchParams) {
    let params = this.parseQueryString(searchParams);
    params = params.filter(
      (param) =>
        param.key !== "filter.v.price.gte" && param.key !== "filter.v.price.lte"
    );

    let removedGte = false;
    let removedLte = false;

    const lastGteMatch = searchParams.match(
      /filter\.v\.price\.gte=\d+(\.\d+)?/g
    );
    const lastLteMatch = searchParams.match(
      /filter\.v\.price\.lte=\d+(\.\d+)?/g
    );

    if (lastGteMatch && lastGteMatch.length > 1) {
      removedGte = true;
    }

    if (lastLteMatch && lastLteMatch.length > 1) {
      removedLte = true;
    }

    if (lastGteMatch) {
      const lastGte = lastGteMatch.pop();
      if (lastGte) {
        const [key, value] = lastGte.split("=");
        params.push({ key, value });
      }
    }

    if (lastLteMatch) {
      const lastLte = lastLteMatch.pop();
      if (lastLte) {
        const [key, value] = lastLte.split("=");
        params.push({ key, value });
      }
    }

    // Reconstruct the query string
    const newQueryString = this.reconstructQueryString(params);
    history.pushState(
      { newQueryString },
      "",
      `${window.location.pathname}${
        newQueryString && "?".concat(newQueryString)
      }`
    );
    if (removedGte || removedLte) {
      window.location.reload();
    }

  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    const params = new URLSearchParams(searchParams);
    params.set('filter.v.availability', '1');
    FacetFiltersForm.renderPage(params.toString(), event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const target = event.currentTarget;
    const href = (target.tagName === 'BUTTON' ? (target.dataset.href || target.dataset.url) : target.href) || '';
    let url = href.indexOf('?') == -1 ? '' : href.slice(href.indexOf('?') + 1);
    
    // Force availability filter on clear
    const params = new URLSearchParams(url);
    params.set('filter.v.availability', '1');
    url = params.toString();

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const el = this.querySelector('button[data-href], button[data-url], a');
    if (el.tagName === 'A') {
      el.setAttribute('role', 'button');
      el.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
    el.addEventListener('click', this.closeFilter.bind(this));
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    const isClearAll = this.classList.contains('active-facets__button-wrapper');

    // Announce individual filter removal, but not when clearing all filters
    if (!isClearAll) {
      const inner = this.querySelector('.active-facets__button-inner');
      if (inner) {
        const clone = inner.cloneNode(true);
        clone.querySelector('.visually-hidden')?.remove();
        clone.querySelector('svg')?.remove();
        const label = clone.textContent.trim();
        if (label) {
          const announcement = document.createElement('div');
          announcement.setAttribute('role', 'status');
          announcement.setAttribute('aria-live', 'assertive');
          announcement.className = 'visually-hidden';
          announcement.textContent = `${label} filter has been removed`;
          document.body.appendChild(announcement);
          setTimeout(() => document.body.removeChild(announcement), 1000);
        }
      }
    }

    if (isClearAll) {
      const announcer = document.createElement('div');
      announcer.setAttribute('aria-live', 'assertive');
      announcer.setAttribute('role', 'alert');
      announcer.setAttribute('aria-atomic', 'true');
      announcer.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;';
      document.body.appendChild(announcer);
      setTimeout(() => { announcer.textContent = window.accessibilityStrings && window.accessibilityStrings.allFiltersRemoved || 'All filters have been removed'; }, 100);
      setTimeout(() => { document.body.removeChild(announcer); }, 3000);
    }

    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);